export default {
  "content": "<path d=\"M13.5 9.75H9.75v3.75c0 .41-.34.75-.75.75a.75.75 0 01-.75-.75V9.75H4.5A.75.75 0 013.75 9c0-.41.34-.75.75-.75h3.75V4.5c0-.41.34-.75.75-.75s.75.34.75.75v3.75h3.75c.41 0 .75.34.75.75s-.34.75-.75.75z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "18",
    "height": "18",
    "viewBox": "0 0 18 18"
  }
};